<template>
  <div class="my-content">
    <div class="left-content">
      <Form
        label-position="right"
        :model="dataDetails"
        :label-width="140"
        :rules="ruleFrom"
        ref="dataDetails"
      >
        <Row>
          <Col :span="12">
            <FormItem :label="$t('airport')" prop="target_airport">
              <Select
                v-model="dataDetails.target_airport"
                filterable
                :placeholder="$t('select') + $t('airport')"
              >
                <Option
                  v-for="item in airportList"
                  :value="item.key"
                  :key="item.key"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('warehouseName')" prop="warehouse_id">
              <Select
                :disabled="transfer"
                v-model="dataDetails.warehouse_id"
                filterable
                :placeholder="warehousePlaceholder"
                @on-change="changeWarehouse(dataDetails.warehouse_id)"
                :filter-by-label="true"
              >
                <Option
                  v-for="item in warehouseList"
                  :value="item.id"
                  :key="item.id"
                  :label="item.title"
                  >{{ item.title }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('clearance_agent')" prop="clearance_agent_id">
              <Select
                v-model="dataDetails.clearance_agent_id"
                filterable
                :placeholder="$t('select') + $t('clearance_agent')"
                :filter-by-label="true"
                @on-change="changeClick(dataDetails.clearance_agent_id)"
              >
                <Option
                  v-for="item in channelList"
                  :value="item.id"
                  :key="item.id"
                  :label="item.agent_name"
                  >{{ item.agent_name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('HKagency')" prop="hk_agent">
              <Select
                v-model="dataDetails.hk_agent"
                filterable
                :placeholder="$t('select') + $t('HKagency')"
                :filter-by-label="true"
              >
                <Option
                  v-for="item in hkAgentList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="12" v-if="!transfer">
            <FormItem :label="$t('packing_number')" prop="packing_number">
              <i-Input
                v-model="dataDetails.packing_number"
                :placeholder="$t('select') + $t('packing_number')"
              ></i-Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$tz('提货,时间')" prop="pickup_time">
              <DatePicker
                type="datetime"
                :placeholder="$tz('提货,时间')"
                style="width: 100%"
                :value="dataDetails.pickup_time"
                @on-change="dataDetails.pickup_time = $event"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('invoiceWeight')" prop="weight">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.weight"
                :placeholder="$t('enter') + $t('invoiceWeight')"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- <Col :span="12"
            ><FormItem :label="$t('invoicePCS')">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.quantity"
                :placeholder="$t('enter') + $t('invoicePCS')"
              ></InputNumber>
            </FormItem>
          </Col> -->
          <Col :span="12">
            <FormItem :label="$t('skuVolume')" prop="volume">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.volume"
                :placeholder="$t('enter') + $t('skuVolume')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('liquidPCS')" prop="liquid_num">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.liquid_num"
                :placeholder="$t('enter') + $t('liquidPCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="$t('ElectricityPCS')" prop="charged_num">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.charged_num"
                :placeholder="$t('enter') + $t('ElectricityPCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem
              :label="$t('Billing') + $t('invoiceWeight')"
              prop="charging_weight"
            >
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.charging_weight"
                :placeholder="$t('enter') + $t('Billing') + $t('invoiceWeight')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem :label="$t('delivery_method')" prop="lower_port">
              <Select
                v-model="dataDetails.lower_port"
                filterable
                :placeholder="$t('select') + $t('delivery_method')"
                :filter-by-label="true"
              >
                <Option
                  v-for="item in downPortList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem :label="$t('order_desc')" prop="remarks">
              <Input
                v-model="dataDetails.remarks"
                type="textarea"
                :placeholder="$t('enter') + $t('order_desc')"
              ></Input>
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem :label="$t('bagCode')" prop="package_id">
              <div class="bag-code">
                <template v-if="packList.length > 0">
                  <div class="check-all">
                    <Tabs v-model="category">
                      <TabPane
                        v-for="item in categorys"
                        :label="(h) => renderLabel(h, item)"
                        :name="item"
                      ></TabPane>
                      <template slot="extra">
                        <Checkbox :value="checkAll" @on-change="handleCheckAll">
                          {{ $t("all") }}
                        </Checkbox>
                        <Checkbox
                          v-for="item in categorys"
                          v-show="item === category && item != 'ALL'"
                          :value="checkGroup[item]"
                          @on-change="handleCheckGroup(item)"
                        >
                          {{ item }}
                        </Checkbox>
                      </template>
                    </Tabs>
                  </div>
                  <div class="check-client">
                    <CheckboxGroup
                      v-model="dataDetails.package_id"
                      @on-change="checkAllGroupChange"
                    >
                      <Row :gutter="10">
                        <Col
                          span="8"
                          v-for="item in packList"
                          :key="item[0]"
                          style="margin-bottom: 10px"
                          v-show="item[1] == category || category === 'ALL'"
                        >
                          <Checkbox :label="item[0]" border></Checkbox>
                        </Col>
                      </Row>
                    </CheckboxGroup>
                  </div>
                </template>
              </div>
            </FormItem>
          </Col>
        </Row>
        <div class="btn-div">
          <!-- <Button
            type="dashed"
            class="submit-btn"
            size="large"
            @click="SearchSubmit"
            icon="md-search"
            :disabled="dataDetails.package_id.length > 0 ? false : true"
          >
            {{ $t("search") }}
          </Button> -->
          <Button
            type="primary"
            class="submit-btn"
            size="large"
            @click="submitClick"
            icon="md-add"
          >
            {{ $t("order_submit") }}
          </Button>
        </div>
      </Form>
    </div>
    <div class="right-content">
      <div class="search-div">
        <i-Input v-model="keywords" placeholder="Please Enter keywords">
        </i-Input>
        <Button
          type="dashed"
          @click="SearchSubmit(keywords)"
          icon="md-search"
          :disabled="dataDetails.package_id.length > 0 ? false : true"
        >
          {{ $t("search") }}
        </Button>
      </div>
      <!-- Table
        border
        :columns="tableTitle"
        :data="tableData"
        stripe
        :loading="loading"
        height="700"
      ></Table> -->
      <vxe-table
        align="center"
        height="700"
        :loading="loading"
        :data="tableData"
      >
        <vxe-column
          field="cnbNum"
          :title="$t('order_number') + ' (' + awoNum + ')'"
        >
          <template #header>
            <span>{{ $t("order_number") + " (" + awoNum + ")" }}</span>
            <Button
              @click="copyList('cnbNum')"
              icon="md-copy"
              size="small"
              style="margin-left: 5px"
            />
          </template>
          <template #default="{ row }">
            <span>{{ row.cnbNum }}</span>
            <Button
              @click="copy(row.cnbNum)"
              icon="md-copy"
              size="small"
              style="margin-left: 5px"
            />
          </template>
        </vxe-column>
        <vxe-column :title="$t('bagCode') + ' (' + bagNum + ')'">
          <template #header>
            <span>{{ $t("bagCode") + " (" + bagNum + ")" }}</span>
            <Button
              @click="copyList('title')"
              icon="md-copy"
              size="small"
              style="margin-left: 5px"
            />
          </template>
          <template #default="{ row }">
            <span>{{ row.title }}</span>
            <Button
              @click="copy(row.title)"
              icon="md-copy"
              size="small"
              style="margin-left: 5px"
            />
          </template>
        </vxe-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import {
  getPickChannel,
  add,
  getPickShipents,
  getPackageWarehouse,
  getDownPort,
} from "@/api/packing/packing";
import { getTransportAgent } from "@/api/tracker/air";
import { getExtractConfig } from "@/api/extract/new";

export default {
  name: "newPacking",
  props: {
    transfer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      warehousePlaceholder: this.$tz("请选择,仓库"),
      category: "all",
      categorys: [],
      badge: {},
      dataDetails: {
        target_airport: "",
        warehouse_id: "",
        packing_number: "",
        channel: "",
        package_id: [],
        hk_agent: "",
        weight: 0,
        // quantity: 0,
        volume: 0,
        liquid_num: 0,
        charged_num: 0,
        charging_weight: 0,
        lower_port: "",
        pickup_time: "",
      },
      airportList: [],
      ruleFrom: {
        target_airport: [
          {
            required: true,
            message: this.$t("select") + this.$t("airport"),
            trigger: "change",
          },
        ],
        pickup_time: [
          {
            required: true,
            message: this.$tz("请选择,提货,时间"),
            trigger: "change",
          },
        ],
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("warehouseName"),
            trigger: "change",
          },
        ],
        // clearance_agent_id: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: this.$t("select") + this.$t("clearance_agent"),
        //     trigger: "change"
        //   }
        // ],
        packing_number: [
          {
            required: true,
            message: this.$t("select") + this.$t("packing_number"),
            trigger: "blur",
          },
        ],
        package_id: [
          {
            required: true,
            type: "array",
            min: 1,
            message: this.$t("select") + this.$t("bagCode"),
            trigger: "change",
          },
        ],
      },
      indeterminate: true,
      checkAll: false,
      checkGroup: {},
      checkAllGroup: [],
      warehouseList: [],
      channelList: [],
      packList: [],
      loading: false,
      objShipments: {},
      tableData: [],
      keywords: "",
      searchData: [],
      hkAgentList: [],
      downPortList: [],
      bagNum: 0,
      awoNum: 0,
      package: [],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("order_number") + " (" + this.awoNum + ")",
        key: "cnbNum",
        align: "center",
      });
      columns.push({
        title: this.$t("bagCode") + " (" + this.bagNum + ")",
        key: "title",
        align: "center",
      });
      return columns;
    },
  },
  mounted() {
    if (this.transfer) {
      this.dataDetails.warehouse_id = this.$store.state.user.info.warehouse_id;
      if (!this.dataDetails.warehouse_id) {
        this.warehousePlaceholder = this.$tz("个人信息没有绑定仓库");
      } else {
        this.getPickChannelList({
          warehouse_id: this.dataDetails.warehouse_id,
        });
      }
    }
    this.getotherList();
  },
  methods: {
    copyList(key) {
      this.copy(this.tableData.map((item) => item[key]).join("\n"));
    },
    copy(content, msg = "") {
      if (window.clipboardData) {
        window.clipboardData.setData("text", content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData("text", content);
            e.preventDefault();
            document.oncopy = null;
          };
        })(content);
        document.execCommand("Copy");
      }
      this.$Message["success"]({
        background: true,
        content: msg + (this.$t("copy") + this.$t("success")),
        duration: 5,
      });
    },
    renderLabel(h, key) {
      return h("div", [
        h("span", key === "ALL" ? this.$t("all") : key),
        h("Badge", {
          props: {
            count: this.badge[key],
          },
        }),
      ]);
    },
    async getotherList() {
      getPackageWarehouse().then((res) => {
        this.warehouseList = res.data.payload;
      });
      getExtractConfig().then((res) => {
        this.airportList = res.data.payload.list.FromStation;
      });
      getTransportAgent({ type: 4 }).then((res) => {
        this.hkAgentList = res.data.payload;
      });
      // getDownPort().then(res => {
      //   this.downPortList = res.data.payload;
      // });
      this.downPortList = await this.$sel.getData("OMS_DISEMBARKATION_METHOD");
    },
    submitClick() {
      this.$refs["dataDetails"].validate((valid) => {
        if (valid) {
          this.dataDetails.transfer = this.transfer;
          add(this.dataDetails).then((res) => {
            if (res.data.code == 0) {
              this.$refs["dataDetails"].resetFields();
              this.packList = [];
              this.tableData = [];
              this.awoNum = this.bagNum = 0;
              this.$Message["success"]({
                background: true,
                content: res.data.msg,
              });
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg,
              });
            }
          });
        }
      });
    },
    SearchSubmit(val) {
      let arr = [];
      if (val) {
        this.searchData.map((item) => {
          if (val == item.title || val == item.cnbNum) {
            arr.push(item);
          }
        });
        this.tableData = arr;
      } else {
        this.tableData = this.searchData;
      }
    },
    changeWarehouse(val) {
      this.checkAll = false;
      this.objShipments = {};
      this.tableData = [];
      this.packList = [];
      this.dataDetails.package_id = [];
      this.awoNum = this.bagNum = 0;
      this.channelList = [];
      this.dataDetails.clearance_agent_id = "";
      this.getPickChannelList({
        warehouse_id: val,
      });
    },
    changeClick(val) {
      this.checkAll = false;
      this.objShipments = {};
      this.tableData = [];
      this.packList = [];
      this.dataDetails.package_id = [];
      this.awoNum = this.bagNum = 0;
      console.log(typeof val);
      if (val) {
        let data = {
          warehouse_id: this.dataDetails.warehouse_id,
          clearance_agent_id: val,
        };
        getPickShipents(data).then((res) => {
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
            });
            return;
          }
          this.packList = []
          let packages = {}
          this.package = {};
          this.category = "ALL";
          this.badge = {};
          this.categorys = Object.keys(res.data.payload.package).reduce((a,b)=>{
            let temp = /^(SA|SM|ST)/.exec(b)
            let item = res.data.payload.package[b];
            let key = b
            if(temp){
              key = temp[0]
              !a.includes(temp[0]) && a.push(temp[0])
            }else{
              a.push(b)
            }
            item.forEach((t) => {
              if(!packages[key])packages[key] = []
              packages[key].push(t)
              return this.packList.push([t, key]);
            });
            return a
          },[]);
          this.package = packages
          this.categorys.unshift("ALL");
          console.log(this.packList, this.categorys,this.package);
          this.objShipments = res.data.payload.shipments;
        });
      }
    },
    getPickChannelList(data) {
      getPickChannel(data).then((res) => {
        this.channelList = res.data.payload;
      });
    },
    handleCheckGroup(item) {
      this.keywords = "";
      this.checkGroup[item] = !this.checkGroup[item];
      this.loading = true;
      let badge = { ALL: 0 };
      if (this.checkGroup[item]) {
        this.dataDetails.package_id = this.packList
          .map((t) => {
            if (this.dataDetails.package_id.includes(t[0]) || t[1] === item) {
              badge[t[1]] = ~~badge[t[1]] + 1;
              return t[0];
            } else return false;
          })
          .filter((t) => t);
      } else {
        this.dataDetails.package_id = this.packList
          .map((t) => {
            if (!this.dataDetails.package_id.includes(t[0]) || t[1] === item) {
              return false;
            } else{
              badge[t[1]] = ~~badge[t[1]] + 1;
              return t[0];
            }
          })
          .filter((t) => t);
      }
      badge.ALL = this.dataDetails.package_id.length;
      this.checkAll =
        this.dataDetails.package_id.length === this.packList.length;
      this.badge = badge;
      let arr = [];
      let bagNum = 0;
      this.dataDetails.package_id.map((key) => {
        bagNum++;
        this.objShipments[key].map((item) => {
          arr.push({ title: key, cnbNum: item });
        });
      });
      this.tableData = this.searchData = arr;
      this.bagNum = bagNum;
      this.awoNum = arr.length;
      this.loading = false;
    },
    handleCheckAll() {
      this.keywords = "";
      this.checkAll = !this.checkAll;
      let badge = { ALL: 0 };
      if (this.checkAll) {
        badge = { ALL: this.packList.length };
        this.loading = true;
        this.dataDetails.package_id = this.packList.map((t) => {
          if (t[1]) {
            badge[t[1]] = ~~badge[t[1]] + 1;
          }
          return t[0];
        });
        let arr = [];
        Object.keys(this.objShipments).forEach((key) => {
          this.objShipments[key].map((item) => {
            arr.push({ title: key, cnbNum: item });
          });
        });
        this.categorys.forEach((t) => (this.checkGroup[t] = true));
        this.tableData = this.searchData = arr;
        this.bagNum = this.packList.length;
        this.awoNum = arr.length;
        this.loading = false;
      } else {
        this.dataDetails.package_id = this.tableData = [];
        this.awoNum = this.bagNum = 0;
        this.categorys.forEach((t) => (this.checkGroup[t] = false));
      }
      this.badge = badge;
    },
    checkAllGroupChange(data) {
      console.log("checkAllGroupChange", data);
      let arr = [];
      this.keywords = "";
      let badge = { ALL: data.length };
      let packages = Object.keys(this.package).reduce((a,b)=>{
        let item = this.package[b];
        item.forEach((t) => {
          a[t] = b
        });
        return a
      },{})
      data.forEach((item) => {
        let key = packages[item];
        badge[key] = ~~badge[key] + 1;
        this.objShipments[item].map((val) => {
          arr.push({ title: item, cnbNum: val });
        });
      });
      this.tableData = this.searchData = arr;
      console.log(this.package,badge);
      this.categorys.forEach((t) => {
        if (t !== "ALL")
          this.checkGroup[t] = badge[t] === this.package[t].length;
      });
      if (data.length === this.packList.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.awoNum = arr.length;
      console.log(data);
      this.bagNum = data.length;
      this.badge = badge;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="less">
.bag-code {
  /deep/ .ivu-tabs-bar {
    margin: 0;
  }
}

.my-content {
  height: 100%;
  display: flex;
}

.left-content {
  width: ~"calc(100% - 500px)";
  height: 100%;
  background: #fff;
  padding: 10px;
}

.right-content {
  width: 470px;
  height: 100%;
  margin-left: 30px;
  background: #fff;
  padding: 10px;
}

.submit-btn {
  width: 150px;
  margin: 0 20px;
}

.btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
}

.search-div {
  display: flex;
  margin-bottom: 24px;
}

.search-div button {
  margin-left: 20px;
}

.bag-code {
  border: 1px solid #dcdee2;
  min-height: 300px;
  border-radius: 4px;
}

.check-all {
  position: absolute;
  width: 100%;
  top: 0;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 15px;
}

.check-client {
  position: absolute;
  top: 40px;
  width: 100%;
  height: calc(100% - 15px);
  overflow: auto;
  padding: 0 10px;
}
</style>
